import * as React from 'react';
import { Posts } from '../Posts';



export const HomeManager =()=>{
    return <Posts />
}